import ApiService from "@/common/api/api.service";

const DashboardExecutoraService = {
    projetosAndamento : function(id) {
        return ApiService.get(`/dashboardExecutora/projetos-andamento?empresaId=${id}`);
    },
    projetosEncerrados : function(id) {
        return ApiService.get(`/dashboardExecutora/projetos-encerrados?empresaId=${id}`);
    },
    saldoDosProjetos : function(id) {
        return ApiService.get(`/dashboardExecutora/saldo-dos-projetos?empresaId=${id}`);
    },
    faturamento : function(id) {
        return ApiService.get(`/dashboardExecutora/faturamento?empresaId=${id}`);
    },
    graficosDespesas : function(id, projetoId) {
        return ApiService.get(`/dashboardExecutora/graficos-despesas?empresaId=${id}&projetoId=${projetoId}`);
    },

    projetos : function(empresaId, grupoNegocio, filtro) {
        return ApiService.get(`/dashboardExecutora/projetos?empresaId=${empresaId}&grupoNegocio=${grupoNegocio}${filtro?.codigoProjeto ? `&CodigoProjeto=${filtro.codigoProjeto}` : ''}${filtro?.faseInovacao ? `&FaseInovacao=${filtro.faseInovacao}` : ''}${filtro?.status ? `&Status=${filtro.status}` : ''}${filtro?.dataInicio ? `&DataInicio=${filtro.dataInicio}` : ''}${filtro?.dataFim ? `&DataFim=${filtro.dataFim}` : ''}`);
    },

};

export default DashboardExecutoraService;
